
import { Payment } from "../types";

// Simple in-memory cache implementation
const cache = {
  payments: new Map<string, {data: Payment[], timestamp: number}>(),
  // Cache expiration time (5 minutes)
  EXPIRY: 5 * 60 * 1000,
  
  get: (key: string) => {
    const cachedItem = cache.payments.get(key);
    if (cachedItem && (Date.now() - cachedItem.timestamp) < cache.EXPIRY) {
      console.log(`Cache hit for ${key}`);
      return cachedItem.data;
    }
    return null;
  },
  
  set: (key: string, data: Payment[]) => {
    console.log(`Caching ${data.length} payments for ${key}`);
    cache.payments.set(key, {
      data,
      timestamp: Date.now()
    });
  },
  
  invalidate: (key?: string) => {
    if (key) {
      cache.payments.delete(key);
    } else {
      cache.payments.clear();
    }
  }
};

/**
 * Service for caching payment data
 */
export const PaymentCacheService = {
  /**
   * Get cached payments by key
   */
  get: (key: string): Payment[] | null => {
    return cache.get(key);
  },
  
  /**
   * Cache payments with a key
   */
  set: (key: string, data: Payment[]): void => {
    cache.set(key, data);
  },
  
  /**
   * Clear cache for specific family, organization, or all
   */
  clearCache: (familyId?: string, organizationId?: string): void => {
    if (familyId) {
      // Clear only specific family cache keys
      [...cache.payments.keys()]
        .filter(key => key.startsWith(`family:${familyId}`))
        .forEach(key => cache.payments.delete(key));
    } else if (organizationId) {
      // Clear only specific organization cache keys
      [...cache.payments.keys()]
        .filter(key => key.startsWith(`org:${organizationId}`))
        .forEach(key => cache.payments.delete(key));
    } else {
      // Clear all cache
      cache.invalidate();
    }
  }
};
